import createClient from 'websocket-rpc-protocol/client';
export function agreeableServer(domain, uid, appVersion, deviceId, serverTimeOffset) {
    const url = `ws${domain.startsWith('localhost') ? '' : 's'}://${domain}/ws${uid ? `/${uid}` : ''}`;
    const client = createClient(url, deviceId, serverTimeOffset);
    client.onError(() => console.error('Error happened'));
    client.onOpen(({ waitUntil }) => {
        // Don't send queued messages until we've finished the handshake
        waitUntil(client.send('info', client.state.get().deviceId, appVersion));
        waitUntil(client.auth());
    });
    return client;
}
